module.exports = __webpack_public_path__ + "img/1-7.03f90799.png";